import { render } from "./DownloadBulkButton.vue?vue&type=template&id=f7add18c"
import script from "./DownloadBulkButton.vue?vue&type=script&lang=js"
export * from "./DownloadBulkButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/denis/Documents/Работа/bitbucket/mifab/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__